import React from 'react';
import { Global, css } from '@emotion/react';
import styled from '@emotion/styled';

import media from 'utils/media';
import theme from 'utils/theme';
import Markdown from 'components/elements/Markdown';

export default function GlobalStylesWrapper() {
  const globalStyles = css`
    body {
      font-family: 'OpenSans';
      font-weight: 500;
      background-color: ${theme.colors.white};
    }

    *:focus {
      outline: none;
    }

    h1,
    h2,
    h3,
    h4 {
      font-family: 'Georgia';
      margin: 0;
    }

    h1 {
      font-size: 28px;
      line-height: 28px;

      ${media.greaterThan.md} {
        font-size: 54px;
        line-height: 61px;
      }
    }

    h2 {
      font-size: 24px;
      line-height: 32px;

      ${media.greaterThan.md} {
        font-size: 42px;
        line-height: 48px;
      }
    }

    h1,
    h2 {
      hyphens: auto;
      hyphenate-limit-chars: 12 3 4;
    }

    h3 {
      font-size: 26px;
      line-height: 30px;

      ${media.greaterThan.md} {
        font-size: 30px;
        line-height: 40px;
      }
    }

    &.chakra-ui-light {
      h3 {
        color: initial;
      }
    }

    h4 {
      font-size: 18px;
      line-height: 22px;

      ${media.greaterThan.md} {
        font-size: 24px;
        line-height: 24px;
      }
    }

    button {
      appearance: none;
      margin: 0;
      padding: 0;
      outline: 0;
      background: none;
      border: 0;
      cursor: pointer;
    }

    a {
      text-decoration: none;
      color: inherit;
    }

    .react-responsive-modal-root {
      z-index: ${theme.zIndex.modal} !important;
    }

    .react-responsive-modal-overlay {
      align-items: flex-start;
      background: rgba(0, 0, 0, 0.75);
      display: flex;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 1.2rem;
    }

    .howItWorks_modal {
      width: calc(100% - 39px);
      padding: 0;
      background: transparent;
      overflow: hidden;

      & > div {
        width: 100%;
      }

      ${media.greaterThan.sm} {
        max-width: 100%;
      }

      ${media.greaterThan.md} {
        max-width: 95%;
      }

      ${media.greaterThan.lg} {
        max-width: 80%;
      }
    }

    .info_modal {
      border-radius: 4px;
      padding: 40px 20px 20px;
      max-width: 400px;

      * {
        font-family: 'OpenSans';
        line-height: 22px;
      }

      h2 {
        font-weight: 700;
        font-size: 1.375rem;
      }

      p {
        font-weight: 500;
        font-size: 1.125rem;
        margin: 0;
      }

      h2 + p,
      h2 + div {
        margin-top: 16px;
      }

      img {
        width: 100%;
      }
    }

    .react-responsive-modal-modal.survey_modal {
      margin: 0;
      padding: 0;
      max-width: 100%;
      width: 100vw;
      height: 100vh;
      overflow-y: hidden;

      ${media.greaterThan.md} {
        max-width: 600px;
      }
    }

    .react-responsive-modal-modal.popup_modal {
      width: 100%;
      max-width: 400px;
      padding-bottom: 0;
      text-align: center;
      margin: auto;
      background-color: transparent;
      box-shadow: unset;

      ${media.greaterThan.md} {
        max-width: 650px;
      }

      .MuiButton-contained {
        min-width: unset;
        width: 100%;
      }
    }

    .react-responsive-modal-modal.popup_modal.impress {
      ${media.lessThan.md} {
        padding: 0;
        max-width: 600px;
      }
    }

    .react-responsive-modal-modal.popup_modal > .react-responsive-modal-closeButton {
      top: 32px;
      right: 32px;
    }

    p > a {
      color: #266ff2;
    }

    .primary-link {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 50px;
      min-width: 260px;
      max-width: calc(100% - 32px);
      font-size: 16px;
      line-height: 21px;
      color: white;
      text-align: center;
      text-transform: uppercase;
      letter-spacing: 3px;
      background-color: #266ff2;
      padding: 15px;
    }

    .outlined-link {
      display: inline-block;
      min-height: 40px;
      min-width: 260px;
      padding: 11px;
      border: 2px solid #000;
      color: #000;
      text-align: center;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 600;
      line-height: 14px;
      letter-spacing: 2px;
    }

    .react-calendar {
      .react-calendar__navigation__next2-button,
      .react-calendar__navigation__prev2-button {
        display: none;
      }
    }

    .typeform-widget {
      height: 100%;
      position: relative;

      > div {
        height: 100%;
      }

      iframe {
        border: 0;
        height: 100%;
        width: 100%;
        overflow: hidden;
        background: transparent;
      }
    }

    // SearchBoxWoosmap - woosmap localities API
    body {
      .localities-container {
        margin-top: 16px;
        border-radius: 12px !important;
        box-shadow: 5px 17px 32px 0px rgba(0, 0, 0, 0.07);
        border-color: #e3e3e3;

        @media screen and (max-width: 720px) {
          width: calc(100% - 46px) !important;
          left: 50% !important;
          min-width: unset;
          transform: translateX(-50%);
        }
        @media screen and (min-width: 720px) and (max-width: 1280px) {
          width: calc(100% - 64px) !important;
          max-width: 625px;
          min-width: unset;
          left: 50% !important;
          transform: translateX(-50%);
        }
      }

      .localities-hidden {
        display: none;
      }

      .localities-item {
        padding-top: 14px;
        padding-bottom: 14px;
        font-size: 0.9rem;
        font-family: 'OpenSans';
        color: #717171;
        padding-left: 35px;
        border-color: #e3e3e3;
      }
      .localities-item:first-of-type {
        border-radius: 12px !important;
      }

      .localities-item-query {
        color: ${theme.colors.black};
      }

      .localities-item-selected,
      .localities-item:hover {
        background-color: ${theme.colors.lightGray};
      }

      .localities-icon {
        background-color: #bbbbbb !important;
        left: 13px !important;
        top: 11px !important;
      }

      .localities-item-selected .localities-icon,
      .localities-item:hover .localities-icon {
        background-color: ${theme.colors.darkGray};
      }
    }

    div#select-registerForm > div > ul {
      max-height: 217px;
      overflow-y: scroll;
    }
  `;

  return <Global styles={globalStyles} />;
}

export const Subheading = styled.span`
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 3.5px;
  text-transform: uppercase;
  color: ${theme.colors.subheading};
`;

export const Lead = styled.p`
  font-size: 16px;
  line-height: 19px;

  ${media.greaterThan.md} {
    font-size: 20px;
    line-height: 30px;
  }
`;

export const LeadMarkdown = styled(Markdown)`
  font-size: 0.938rem;
  line-height: 20px;
  margin: 24px auto 19px;

  li {
    &::before {
      content: '✓ ';
    }

    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: ${({ theme }) => theme.colors.accent};
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  }

  ${media.greaterThan.md} {
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 27px;
  }
`;
